export default __webpack_public_path__ + "static/media/project-mgt.ec873e5b.webp";